require("core-js/modules/es.array.flat.js");

require("core-js/modules/es.array.flat.js");

module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = "./src/index.tsx");
  /******/
}(
/************************************************************************/

/******/
{
  /***/
  "./src/index.tsx":
  /***/
  function srcIndexTsx(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;

    var _react = _interopRequireDefault(__webpack_require__("react"));

    var _styledComponents = _interopRequireDefault(__webpack_require__("styled-components"));

    var _coreDeliveryOrPickup = _interopRequireDefault(__webpack_require__("@carvana/core-delivery-or-pickup"));

    var _nanoid = __webpack_require__("nanoid");

    var _parsers = __webpack_require__("./src/parsers/index.ts");

    var _utils = __webpack_require__("./src/utils/index.ts");

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var DeliveryOrPickupComponent = function DeliveryOrPickupComponent(props) {
      var key = props.key,
          cb = props.cb,
          data = props.data;

      var _ref = data || {},
          _ref$user = _ref.user;

      _ref$user = _ref$user === void 0 ? {} : _ref$user;
      var _ref$user$accessToken = _ref$user.accessToken,
          accessToken = _ref$user$accessToken === void 0 ? '' : _ref$user$accessToken,
          externalData = _ref.externalData;
      var DeliveryOrPickupWrapper = (0, _styledComponents.default)(_coreDeliveryOrPickup.default).withConfig({
        displayName: "DeliveryOrPickupWrapper",
        componentId: "oewzle-0"
      })(["> div:nth-child(1){text-align:left;}"]); // this callback function calls the setExternalData function from article-content
      // which will update externalData state, and can be used to pass in data from external component

      var callback = function callback(resp) {
        return cb && cb(function (setExternalData) {
          var _resp$soonestDelivery, _resp$userLocation, _resp$userLocation2, _resp$userLocation3;

          setExternalData({
            user: {
              isOutOfMarket: resp === null || resp === void 0 ? void 0 : (_resp$soonestDelivery = resp.soonestDeliveryAvailable) === null || _resp$soonestDelivery === void 0 ? void 0 : _resp$soonestDelivery.isThirdPartyDelivery,
              city: resp === null || resp === void 0 ? void 0 : (_resp$userLocation = resp.userLocation) === null || _resp$userLocation === void 0 ? void 0 : _resp$userLocation.city,
              state: resp === null || resp === void 0 ? void 0 : (_resp$userLocation2 = resp.userLocation) === null || _resp$userLocation2 === void 0 ? void 0 : _resp$userLocation2.state,
              zip5: resp === null || resp === void 0 ? void 0 : (_resp$userLocation3 = resp.userLocation) === null || _resp$userLocation3 === void 0 ? void 0 : _resp$userLocation3.zip5
            },
            externalData: resp
          });
        });
      };

      return /*#__PURE__*/_react.default.createElement(DeliveryOrPickupWrapper, {
        userAccessToken: accessToken,
        env: Object({}).GATSBY_ENV === 'non-prod' ? 'test' : 'production',
        key: key,
        cb: callback,
        showCaption: false,
        data: externalData
      });
    };

    var ArticleRenderer = /*#__PURE__*/function () {
      function ArticleRenderer() {}

      ArticleRenderer.render = function render(content, userData, cb, tempExtraProps) {
        if (false) {}

        var customComponents = [{
          name: 'DeliveryOrPickup',
          component: DeliveryOrPickupComponent
        }];

        try {
          // only allow for strings
          if (!(0, _utils.isString)(content)) throw new Error('unable to parse non-string content'); // the if statement regex needs to scan the whole string and parse.

          var replacedContent = (0, _parsers.ifBlockStatement)({
            data: userData,
            content: content
          });
          if (!replacedContent) throw new Error('Unable to parse article'); // temp hack to allow to pass-in a gatsby-link component to render internal links in articles

          var _ref2 = tempExtraProps || {},
              TempGatsbyUrlLink = _ref2.TempGatsbyUrlLink; //! If application starts to slow down, look into having nanoid key declared inside funcs instead.


          var key = (0, _nanoid.nanoid)(); // if its a string, split on \n, and then loop through each row and run through regex to get match

          var components = replacedContent.split('\n').map(function (row) {
            // for now, these pipe funtions must be in this order!
            // TODO: update everything above boldItalic to accept an array that loops thorugh all elements
            var parsed = (0, _utils.pipe)((0, _parsers.mustache)({
              data: userData
            }), (0, _parsers.emptyLine)({
              key: key
            }), (0, _parsers.header)({
              key: key
            }), (0, _parsers.orderedList)({
              key: key
            }), (0, _parsers.unOrderedList)({
              key: key
            }), (0, _parsers.boldItalic)(), (0, _parsers.urlLink)({
              key: key,
              TempGatsbyUrlLink: TempGatsbyUrlLink
            }), (0, _parsers.quote)({
              key: key
            }), (0, _parsers.inlineImage)({
              key: key
            }), (0, _parsers.getCustomComponents)({
              key: key,
              components: customComponents,
              data: userData,
              cb: cb
            }))(row);
            return parsed;
          });

          if (false) {}

          return components;
        } catch (error) {
          console.error('failed to parseMarkdown', {
            error: error,
            content: content
          });
          return null;
        }
      };

      return ArticleRenderer;
    }();

    exports.default = ArticleRenderer;
    /***/
  },

  /***/
  "./src/parsers/bold/index.tsx":
  /***/
  function srcParsersBoldIndexTsx(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.boldItalic = void 0;

    var _nanoid = __webpack_require__("nanoid");

    var _react = _interopRequireDefault(__webpack_require__("react"));

    var _styledComponents = _interopRequireDefault(__webpack_require__("styled-components"));

    var _utils = __webpack_require__("./src/utils/index.ts");

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    } // @ts-nocheck


    var BoldAndItalicType = _styledComponents.default.span.withConfig({
      displayName: "BoldAndItalicType",
      componentId: "sc-6kbfx-0"
    })(["", ";", ";"], function (props) {
      return props.italic && 'font-style: italic';
    }, function (props) {
      return props.bold && 'font-weight: 700';
    });

    var splitBoldItalic = function splitBoldItalic(str) {
      var preparsedArr = [];
      var parsedArr = [];
      var strPointer = 0; // all asterisks included

      for (var i = 0; i < str.length; i++) {
        if (str[i] === '*' && str[i - 1] === '\\') {
          str = str.slice(strPointer, i - 1) + str.slice(i);
          continue;
        } else if (str[i] === '*') {
          preparsedArr.push(str.substring(strPointer, i));

          if (str[i + 1] === '*' && str[i + 2] === '*') {
            // bold && italic
            preparsedArr.push('***');
            strPointer = i + 3;
            i += 3;
          } else if (str[i + 1] === '*') {
            // bold
            preparsedArr.push('**');
            strPointer = i + 2;
            i += 2;
          } else {
            // italic
            preparsedArr.push('*');
            strPointer = i + 1;
            i += 1;
          }

          var strHasNoAsterisk = !str.substring(strPointer).includes('*');

          if (strHasNoAsterisk) {
            preparsedArr.push(str.substring(strPointer));
          }
        }
      } // 2nd half of asterisks removed


      var asteriskCounter = 0;

      for (var _i = 0; _i < preparsedArr.length; _i++) {
        if (preparsedArr[_i] === '*' || preparsedArr[_i] === '**' || preparsedArr[_i] === '***') {
          asteriskCounter++;
          var isAsteriskEven = asteriskCounter % 2 === 0;

          if (!isAsteriskEven) {
            parsedArr.push(preparsedArr[_i]);
          }
        } else {
          parsedArr.push(preparsedArr[_i]);
        }
      }

      return parsedArr;
    };

    var boldItalic = function boldItalic() {
      return function (content) {
        return (0, _utils.getChildComponents)(content, function (comp) {
          var splitContent = splitBoldItalic(comp);
          if (!splitContent || (splitContent === null || splitContent === void 0 ? void 0 : splitContent.length) === 1) return comp;
          return splitContent.map(function (sc, i) {
            var hasNoAsterisks = !(sc === '*' || sc === '**' || sc === '***');
            var isItalic = splitContent[i - 1] === '*' || splitContent[i - 1] === '***';
            var isBold = splitContent[i - 1] === '**' || splitContent[i - 1] === '***';

            if (hasNoAsterisks) {
              return /*#__PURE__*/_react.default.createElement(BoldAndItalicType, {
                key: (0, _nanoid.nanoid)(),
                bold: isBold,
                italic: isItalic
              }, sc);
            }
          }).filter(Boolean);
        });
      };
    };

    exports.boldItalic = boldItalic;
    /***/
  },

  /***/
  "./src/parsers/custom-components/index.tsx":
  /***/
  function srcParsersCustomComponentsIndexTsx(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.getCustomComponents = void 0;

    var _react = _interopRequireDefault(__webpack_require__("react"));

    var _utils = __webpack_require__("./src/utils/index.ts");

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _extends() {
      _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      return _extends.apply(this, arguments);
    }

    function _wrapRegExp(re, groups) {
      _wrapRegExp = function _wrapRegExp(re, groups) {
        return new BabelRegExp(re, undefined, groups);
      };

      var _RegExp = _wrapNativeSuper(RegExp);

      var _super = RegExp.prototype;

      var _groups = new WeakMap();

      function BabelRegExp(re, flags, groups) {
        var _this = _RegExp.call(this, re, flags);

        _groups.set(_this, groups || _groups.get(re));

        return _this;
      }

      _inherits(BabelRegExp, _RegExp);

      BabelRegExp.prototype.exec = function (str) {
        var result = _super.exec.call(this, str);

        if (result) result.groups = buildGroups(result, this);
        return result;
      };

      BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
        if (typeof substitution === "string") {
          var groups = _groups.get(this);

          return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
            return "$" + groups[name];
          }));
        } else if (typeof substitution === "function") {
          var _this = this;

          return _super[Symbol.replace].call(this, str, function () {
            var args = [];
            args.push.apply(args, arguments);

            if (typeof args[args.length - 1] !== "object") {
              args.push(buildGroups(args, _this));
            }

            return substitution.apply(this, args);
          });
        } else {
          return _super[Symbol.replace].call(this, str, substitution);
        }
      };

      function buildGroups(result, re) {
        var g = _groups.get(re);

        return Object.keys(g).reduce(function (groups, name) {
          groups[name] = result[g[name]];
          return groups;
        }, Object.create(null));
      }

      return _wrapRegExp.apply(this, arguments);
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          writable: true,
          configurable: true
        }
      });
      if (superClass) _setPrototypeOf(subClass, superClass);
    }

    function _possibleConstructorReturn(self, call) {
      if (call && (typeof call === "object" || typeof call === "function")) {
        return call;
      }

      return _assertThisInitialized(self);
    }

    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return self;
    }

    function _wrapNativeSuper(Class) {
      var _cache = typeof Map === "function" ? new Map() : undefined;

      _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;

        if (typeof Class !== "function") {
          throw new TypeError("Super expression must either be null or a function");
        }

        if (typeof _cache !== "undefined") {
          if (_cache.has(Class)) return _cache.get(Class);

          _cache.set(Class, Wrapper);
        }

        function Wrapper() {
          return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }

        Wrapper.prototype = Object.create(Class.prototype, {
          constructor: {
            value: Wrapper,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        return _setPrototypeOf(Wrapper, Class);
      };

      return _wrapNativeSuper(Class);
    }

    function _construct(Parent, args, Class) {
      if (_isNativeReflectConstruct()) {
        _construct = Reflect.construct;
      } else {
        _construct = function _construct(Parent, args, Class) {
          var a = [null];
          a.push.apply(a, args);
          var Constructor = Function.bind.apply(Parent, a);
          var instance = new Constructor();
          if (Class) _setPrototypeOf(instance, Class.prototype);
          return instance;
        };
      }

      return _construct.apply(null, arguments);
    }

    function _isNativeReflectConstruct() {
      if (typeof Reflect === "undefined" || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if (typeof Proxy === "function") return true;

      try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        return true;
      } catch (e) {
        return false;
      }
    }

    function _isNativeFunction(fn) {
      return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }

    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };

      return _setPrototypeOf(o, p);
    }

    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
      return _getPrototypeOf(o);
    } // only works with <xxxx ddd=fff />>
    // const codeBlockRegex = /<(?<name>[a-zA-Z1-6]+)(\s|\n)(?<props>[^<]+)/i;
    // this one works with <aaaa>xxxx</aaaa>


    var codeBlockRegex = /*#__PURE__*/_wrapRegExp(/<([1-6A-Za-z]+)([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]|\n)?((?:(?!<)[\s\S])+)?(?:>(.*)<\/\1>|[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+\/>)/i, {
      name: 1,
      props: 3,
      content: 4
    }); // const codeBlockRegex = /<(?<name>[a-zA-Z1-6]+)(?<props>[^<]+)*(?:>(?<content>.*)<\/\1>|\s+\/>)/i;


    var getCustomComponents = function getCustomComponents(_ref) {
      var components = _ref.components,
          key = _ref.key,
          data = _ref.data,
          cb = _ref.cb;
      return function (content) {
        return (0, _utils.getChildComponents)(content, function (comp) {
          var codeBlockMatch = comp.match(codeBlockRegex); // if we have a match, then we need to check if that component exists
          // in the components object array

          if (codeBlockMatch && (codeBlockMatch === null || codeBlockMatch === void 0 ? void 0 : codeBlockMatch.length) > 0) {
            var _codeBlockMatch$group = codeBlockMatch.groups,
                name = _codeBlockMatch$group.name,
                props = _codeBlockMatch$group.props,
                _content = _codeBlockMatch$group.content;
            var componentMatchFound = components.find(function (x) {
              return x.name === name;
            });

            if (componentMatchFound) {
              // split the comp on the codeblock match so we can get before/after text
              var beforeAfterContent = comp.split(codeBlockMatch[0]).filter(Boolean);
              var fixedProps = props && props.split(' ').map(function (x) {
                return x.split('=');
              }).reduce(function (acc, _ref2) {
                var _extends2;

                var name = _ref2[0],
                    value = _ref2[1];
                return _extends({}, acc, (_extends2 = {}, _extends2[name] = value && value.replace(/"/g, '') || false, _extends2));
              }, {});

              if (beforeAfterContent && beforeAfterContent.length > 0) {
                // we have before and after text that we also need to return
                return /*#__PURE__*/_react.default.createElement("span", {
                  key: key
                }, beforeAfterContent[0], componentMatchFound.component(_extends({}, fixedProps, {
                  content: _content,
                  data: data,
                  key: key,
                  cb: cb
                })), beforeAfterContent[1]);
              } else {
                return /*#__PURE__*/_react.default.createElement("div", {
                  ref: componentMatchFound.ref,
                  key: key
                }, componentMatchFound.component(_extends({}, fixedProps, {
                  content: _content,
                  data: data,
                  key: key,
                  cb: cb
                })));
              }
            }
          }

          return comp;
        });
      };
    };

    exports.getCustomComponents = getCustomComponents;
    /***/
  },

  /***/
  "./src/parsers/empty-line/index.tsx":
  /***/
  function srcParsersEmptyLineIndexTsx(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.emptyLine = void 0;

    var _react = _interopRequireDefault(__webpack_require__("react"));

    var _styledComponents = _interopRequireDefault(__webpack_require__("styled-components"));

    var _utils = __webpack_require__("./src/utils/index.ts");

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    } // @ts-nocheck


    var Empty = _styledComponents.default.div.withConfig({
      displayName: "Empty",
      componentId: "sc-608c6a-0"
    })(["margin:1.5rem;"]);

    var emptyLine = function emptyLine(_ref) {
      var key = _ref.key;
      return function (content) {
        if ((0, _utils.isElement)(content)) return content;
        if (!content) return /*#__PURE__*/_react.default.createElement(Empty, {
          key: key
        });
        return content;
      };
    };

    exports.emptyLine = emptyLine;
    /***/
  },

  /***/
  "./src/parsers/headers/index.tsx":
  /***/
  function srcParsersHeadersIndexTsx(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.header = void 0;

    var _react = _interopRequireDefault(__webpack_require__("react"));

    var _styledComponents = _interopRequireDefault(__webpack_require__("styled-components"));

    var _utils = __webpack_require__("./src/utils/index.ts");

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _wrapRegExp(re, groups) {
      _wrapRegExp = function _wrapRegExp(re, groups) {
        return new BabelRegExp(re, undefined, groups);
      };

      var _RegExp = _wrapNativeSuper(RegExp);

      var _super = RegExp.prototype;

      var _groups = new WeakMap();

      function BabelRegExp(re, flags, groups) {
        var _this = _RegExp.call(this, re, flags);

        _groups.set(_this, groups || _groups.get(re));

        return _this;
      }

      _inherits(BabelRegExp, _RegExp);

      BabelRegExp.prototype.exec = function (str) {
        var result = _super.exec.call(this, str);

        if (result) result.groups = buildGroups(result, this);
        return result;
      };

      BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
        if (typeof substitution === "string") {
          var groups = _groups.get(this);

          return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
            return "$" + groups[name];
          }));
        } else if (typeof substitution === "function") {
          var _this = this;

          return _super[Symbol.replace].call(this, str, function () {
            var args = [];
            args.push.apply(args, arguments);

            if (typeof args[args.length - 1] !== "object") {
              args.push(buildGroups(args, _this));
            }

            return substitution.apply(this, args);
          });
        } else {
          return _super[Symbol.replace].call(this, str, substitution);
        }
      };

      function buildGroups(result, re) {
        var g = _groups.get(re);

        return Object.keys(g).reduce(function (groups, name) {
          groups[name] = result[g[name]];
          return groups;
        }, Object.create(null));
      }

      return _wrapRegExp.apply(this, arguments);
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          writable: true,
          configurable: true
        }
      });
      if (superClass) _setPrototypeOf(subClass, superClass);
    }

    function _possibleConstructorReturn(self, call) {
      if (call && (typeof call === "object" || typeof call === "function")) {
        return call;
      }

      return _assertThisInitialized(self);
    }

    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return self;
    }

    function _wrapNativeSuper(Class) {
      var _cache = typeof Map === "function" ? new Map() : undefined;

      _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;

        if (typeof Class !== "function") {
          throw new TypeError("Super expression must either be null or a function");
        }

        if (typeof _cache !== "undefined") {
          if (_cache.has(Class)) return _cache.get(Class);

          _cache.set(Class, Wrapper);
        }

        function Wrapper() {
          return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }

        Wrapper.prototype = Object.create(Class.prototype, {
          constructor: {
            value: Wrapper,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        return _setPrototypeOf(Wrapper, Class);
      };

      return _wrapNativeSuper(Class);
    }

    function _construct(Parent, args, Class) {
      if (_isNativeReflectConstruct()) {
        _construct = Reflect.construct;
      } else {
        _construct = function _construct(Parent, args, Class) {
          var a = [null];
          a.push.apply(a, args);
          var Constructor = Function.bind.apply(Parent, a);
          var instance = new Constructor();
          if (Class) _setPrototypeOf(instance, Class.prototype);
          return instance;
        };
      }

      return _construct.apply(null, arguments);
    }

    function _isNativeReflectConstruct() {
      if (typeof Reflect === "undefined" || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if (typeof Proxy === "function") return true;

      try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        return true;
      } catch (e) {
        return false;
      }
    }

    function _isNativeFunction(fn) {
      return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }

    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };

      return _setPrototypeOf(o, p);
    }

    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
      return _getPrototypeOf(o);
    }

    var HeaderOne = _styledComponents.default.h1.withConfig({
      displayName: "HeaderOne",
      componentId: "qvr80q-0"
    })(["padding-bottom:5px;line-height:32px;font-size:28px;color:", ";"], function (props) {
      return props.theme.color.primary.v600;
    });

    var HeaderTwo = _styledComponents.default.h2.withConfig({
      displayName: "HeaderTwo",
      componentId: "qvr80q-1"
    })(["padding-bottom:5px;"]);

    var HeaderThree = _styledComponents.default.h3.withConfig({
      displayName: "HeaderThree",
      componentId: "qvr80q-2"
    })(["padding-bottom:5px;"]);

    var headingRegex = /*#__PURE__*/_wrapRegExp(/(#+[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*)(.*)/i, {
      heading: 2
    });

    var header = function header(_ref) {
      var key = _ref.key;
      return function (content) {
        var _headerMatch$groups, _headerMatch$groups2, _headerMatch$groups3;

        if ((0, _utils.isElement)(content) && !(0, _utils.hasChildren)(content)) return content;
        var headerMatch = (0, _utils.isString)(content) && content.match(headingRegex);

        if (headerMatch && headerMatch.length > 0) {
          switch (headerMatch[1].trim().length) {
            case 2:
              return /*#__PURE__*/_react.default.createElement(HeaderTwo, {
                key: key
              }, headerMatch === null || headerMatch === void 0 ? void 0 : (_headerMatch$groups = headerMatch.groups) === null || _headerMatch$groups === void 0 ? void 0 : _headerMatch$groups.heading);

            case 3:
              return /*#__PURE__*/_react.default.createElement(HeaderThree, {
                key: key
              }, headerMatch === null || headerMatch === void 0 ? void 0 : (_headerMatch$groups2 = headerMatch.groups) === null || _headerMatch$groups2 === void 0 ? void 0 : _headerMatch$groups2.heading);

            default:
              return /*#__PURE__*/_react.default.createElement(HeaderOne, {
                key: key
              }, headerMatch === null || headerMatch === void 0 ? void 0 : (_headerMatch$groups3 = headerMatch.groups) === null || _headerMatch$groups3 === void 0 ? void 0 : _headerMatch$groups3.heading);
          }
        }

        return content;
      };
    };

    exports.header = header;
    /***/
  },

  /***/
  "./src/parsers/if-statement/index.tsx":
  /***/
  function srcParsersIfStatementIndexTsx(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.ifBlockStatement = void 0;

    var _isString = __webpack_require__("./src/utils/is-string/index.ts");

    function _wrapRegExp(re, groups) {
      _wrapRegExp = function _wrapRegExp(re, groups) {
        return new BabelRegExp(re, undefined, groups);
      };

      var _RegExp = _wrapNativeSuper(RegExp);

      var _super = RegExp.prototype;

      var _groups = new WeakMap();

      function BabelRegExp(re, flags, groups) {
        var _this = _RegExp.call(this, re, flags);

        _groups.set(_this, groups || _groups.get(re));

        return _this;
      }

      _inherits(BabelRegExp, _RegExp);

      BabelRegExp.prototype.exec = function (str) {
        var result = _super.exec.call(this, str);

        if (result) result.groups = buildGroups(result, this);
        return result;
      };

      BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
        if (typeof substitution === "string") {
          var groups = _groups.get(this);

          return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
            return "$" + groups[name];
          }));
        } else if (typeof substitution === "function") {
          var _this = this;

          return _super[Symbol.replace].call(this, str, function () {
            var args = [];
            args.push.apply(args, arguments);

            if (typeof args[args.length - 1] !== "object") {
              args.push(buildGroups(args, _this));
            }

            return substitution.apply(this, args);
          });
        } else {
          return _super[Symbol.replace].call(this, str, substitution);
        }
      };

      function buildGroups(result, re) {
        var g = _groups.get(re);

        return Object.keys(g).reduce(function (groups, name) {
          groups[name] = result[g[name]];
          return groups;
        }, Object.create(null));
      }

      return _wrapRegExp.apply(this, arguments);
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          writable: true,
          configurable: true
        }
      });
      if (superClass) _setPrototypeOf(subClass, superClass);
    }

    function _possibleConstructorReturn(self, call) {
      if (call && (typeof call === "object" || typeof call === "function")) {
        return call;
      }

      return _assertThisInitialized(self);
    }

    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return self;
    }

    function _wrapNativeSuper(Class) {
      var _cache = typeof Map === "function" ? new Map() : undefined;

      _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;

        if (typeof Class !== "function") {
          throw new TypeError("Super expression must either be null or a function");
        }

        if (typeof _cache !== "undefined") {
          if (_cache.has(Class)) return _cache.get(Class);

          _cache.set(Class, Wrapper);
        }

        function Wrapper() {
          return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }

        Wrapper.prototype = Object.create(Class.prototype, {
          constructor: {
            value: Wrapper,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        return _setPrototypeOf(Wrapper, Class);
      };

      return _wrapNativeSuper(Class);
    }

    function _construct(Parent, args, Class) {
      if (_isNativeReflectConstruct()) {
        _construct = Reflect.construct;
      } else {
        _construct = function _construct(Parent, args, Class) {
          var a = [null];
          a.push.apply(a, args);
          var Constructor = Function.bind.apply(Parent, a);
          var instance = new Constructor();
          if (Class) _setPrototypeOf(instance, Class.prototype);
          return instance;
        };
      }

      return _construct.apply(null, arguments);
    }

    function _isNativeReflectConstruct() {
      if (typeof Reflect === "undefined" || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if (typeof Proxy === "function") return true;

      try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        return true;
      } catch (e) {
        return false;
      }
    }

    function _isNativeFunction(fn) {
      return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }

    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };

      return _setPrototypeOf(o, p);
    }

    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
      return _getPrototypeOf(o);
    }

    var ifBlockRegex = /(\{\{#if[\s\S]*\}\})([\s\S]*)\{\{\/if\}\}/i;
    var fullIfBlockRegex = /\{\{#if\s(.+)\}\}/i;

    var leftComparisonRightRegex = /*#__PURE__*/_wrapRegExp(/(.*?)(([!=]={2}|[<>\|]=?))(.*)|(default)/i, {
      left_statement: 1,
      comparison: 2,
      right_statement: 4,
      default_statement: 5
    }); // TODO: add multiple if statements?? (if === a || if === b)


    var ifBlockStatement = function ifBlockStatement(_ref) {
      var data = _ref.data,
          content = _ref.content;

      try {
        var ifBlockStatementMatch = typeof content === 'string' && content.match(ifBlockRegex);

        if (ifBlockStatementMatch) {
          // we get the full if block statement - {{#if}} -> {{/if}}
          var fullIfBlockStatement = ifBlockStatementMatch[0]; // now that we know there is an #if block
          // we need to get each #if block, and evaluate

          var ifStatementMatch = [];
          var defaultIndex = false; // split on if statements

          var parsedIfStatements = fullIfBlockStatement.split(fullIfBlockRegex).filter(Boolean); // loop through each if statement

          for (var index = 0; index < parsedIfStatements.length; index += 2) {
            var _fullStatement$match, _left_statement$trim, _left_statement$trim$, _right_statement$trim; // only if statements should be here, as we skipped every other index


            var fullStatement = parsedIfStatements[index]; // run through regex - get left, comparison, right, and default statements

            var _fullStatement$match$ = fullStatement === null || fullStatement === void 0 ? void 0 : (_fullStatement$match = fullStatement.match(leftComparisonRightRegex)) === null || _fullStatement$match === void 0 ? void 0 : _fullStatement$match.groups,
                left_statement = _fullStatement$match$.left_statement,
                comparison = _fullStatement$match$.comparison,
                right_statement = _fullStatement$match$.right_statement,
                default_statement = _fullStatement$match$.default_statement; // look for the default statement, and keep track of it. this will be our fallback if nothing matches


            if (default_statement) defaultIndex = index + 1; // we need to only get the data portion so we can match the data and get the values

            var leftStatementReplacedByData = !default_statement && (left_statement === null || left_statement === void 0 ? void 0 : (_left_statement$trim = left_statement.trim()) === null || _left_statement$trim === void 0 ? void 0 : (_left_statement$trim$ = _left_statement$trim.split('.')) === null || _left_statement$trim$ === void 0 ? void 0 : _left_statement$trim$.reduce(function (o, i) {
              return o && o[i];
            }, data)); // now that we have replaced the values with real data, eval the statement and see if we have a match
            // eval("left_statement" comparison right_statement)
            // we also check to see if left_statement is a string, if it is, then wrap it in quotes so it can properly be compared - only applies to strings

            var isIfStatementTrue = !default_statement && eval(((0, _isString.isString)(leftStatementReplacedByData) ? "\"" + (leftStatementReplacedByData === null || leftStatementReplacedByData === void 0 ? void 0 : leftStatementReplacedByData.toLowerCase()) + "\"" : leftStatementReplacedByData) + " " + comparison.trim() + " " + ((0, _isString.isString)(right_statement) ? (_right_statement$trim = right_statement.trim()) === null || _right_statement$trim === void 0 ? void 0 : _right_statement$trim.toLowerCase() : right_statement.trim())); // if the statement is true, keep track of the index

            if (isIfStatementTrue) {
              // @ts-ignore
              ifStatementMatch.push(index + 1);
            }
          } // check for multiple if statement matches


          if ((ifStatementMatch === null || ifStatementMatch === void 0 ? void 0 : ifStatementMatch.length) > 0) {
            // since we have more than one if statment match, we need to only get those if statement content, and then replace the full if block statement with their results
            return content.replace(fullIfBlockStatement, ifStatementMatch.map(function (ifStatement) {
              return parsedIfStatements[ifStatement];
            }).join('\n')).replace('{{/if}}', '');
          }

          if (defaultIndex && defaultIndex >= 0) {
            // using the defalut if statement
            return content.replace(fullIfBlockStatement, parsedIfStatements[defaultIndex]).replace('{{/if}}', '');
          }

          if ((ifStatementMatch === null || ifStatementMatch === void 0 ? void 0 : ifStatementMatch.length) === 0 && !defaultIndex) {
            // no match found, and also no default option provided - remove all if statements
            return content.replace(fullIfBlockStatement, '').replace('{{/if}}', '');
          } // nothing found, no replacement neeed


          return content;
        }
      } catch (error) {
        console.error('if statement regex failed', error);
      }

      return content;
    };

    exports.ifBlockStatement = ifBlockStatement;
    /***/
  },

  /***/
  "./src/parsers/index.ts":
  /***/
  function srcParsersIndexTs(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _bold = __webpack_require__("./src/parsers/bold/index.tsx");

    Object.keys(_bold).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      if (key in exports && exports[key] === _bold[key]) return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _bold[key];
        }
      });
    });

    var _emptyLine = __webpack_require__("./src/parsers/empty-line/index.tsx");

    Object.keys(_emptyLine).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      if (key in exports && exports[key] === _emptyLine[key]) return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _emptyLine[key];
        }
      });
    });

    var _headers = __webpack_require__("./src/parsers/headers/index.tsx");

    Object.keys(_headers).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      if (key in exports && exports[key] === _headers[key]) return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _headers[key];
        }
      });
    });

    var _ifStatement = __webpack_require__("./src/parsers/if-statement/index.tsx");

    Object.keys(_ifStatement).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      if (key in exports && exports[key] === _ifStatement[key]) return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _ifStatement[key];
        }
      });
    });

    var _lists = __webpack_require__("./src/parsers/lists/index.tsx");

    Object.keys(_lists).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      if (key in exports && exports[key] === _lists[key]) return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _lists[key];
        }
      });
    });

    var _mustache = __webpack_require__("./src/parsers/mustache/index.tsx");

    Object.keys(_mustache).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      if (key in exports && exports[key] === _mustache[key]) return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _mustache[key];
        }
      });
    });

    var _urlLink = __webpack_require__("./src/parsers/url-link/index.tsx");

    Object.keys(_urlLink).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      if (key in exports && exports[key] === _urlLink[key]) return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _urlLink[key];
        }
      });
    });

    var _quote = __webpack_require__("./src/parsers/quote/index.tsx");

    Object.keys(_quote).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      if (key in exports && exports[key] === _quote[key]) return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _quote[key];
        }
      });
    });

    var _customComponents = __webpack_require__("./src/parsers/custom-components/index.tsx");

    Object.keys(_customComponents).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      if (key in exports && exports[key] === _customComponents[key]) return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _customComponents[key];
        }
      });
    });

    var _inlineImage = __webpack_require__("./src/parsers/inline-image/index.tsx");

    Object.keys(_inlineImage).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      if (key in exports && exports[key] === _inlineImage[key]) return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _inlineImage[key];
        }
      });
    });
    /***/
  },

  /***/
  "./src/parsers/inline-image/index.tsx":
  /***/
  function srcParsersInlineImageIndexTsx(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.inlineImage = void 0;

    var _react = _interopRequireDefault(__webpack_require__("react"));

    var _styledComponents = _interopRequireDefault(__webpack_require__("styled-components"));

    var _utils = __webpack_require__("./src/utils/index.ts");

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _wrapRegExp(re, groups) {
      _wrapRegExp = function _wrapRegExp(re, groups) {
        return new BabelRegExp(re, undefined, groups);
      };

      var _RegExp = _wrapNativeSuper(RegExp);

      var _super = RegExp.prototype;

      var _groups = new WeakMap();

      function BabelRegExp(re, flags, groups) {
        var _this = _RegExp.call(this, re, flags);

        _groups.set(_this, groups || _groups.get(re));

        return _this;
      }

      _inherits(BabelRegExp, _RegExp);

      BabelRegExp.prototype.exec = function (str) {
        var result = _super.exec.call(this, str);

        if (result) result.groups = buildGroups(result, this);
        return result;
      };

      BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
        if (typeof substitution === "string") {
          var groups = _groups.get(this);

          return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
            return "$" + groups[name];
          }));
        } else if (typeof substitution === "function") {
          var _this = this;

          return _super[Symbol.replace].call(this, str, function () {
            var args = [];
            args.push.apply(args, arguments);

            if (typeof args[args.length - 1] !== "object") {
              args.push(buildGroups(args, _this));
            }

            return substitution.apply(this, args);
          });
        } else {
          return _super[Symbol.replace].call(this, str, substitution);
        }
      };

      function buildGroups(result, re) {
        var g = _groups.get(re);

        return Object.keys(g).reduce(function (groups, name) {
          groups[name] = result[g[name]];
          return groups;
        }, Object.create(null));
      }

      return _wrapRegExp.apply(this, arguments);
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          writable: true,
          configurable: true
        }
      });
      if (superClass) _setPrototypeOf(subClass, superClass);
    }

    function _possibleConstructorReturn(self, call) {
      if (call && (typeof call === "object" || typeof call === "function")) {
        return call;
      }

      return _assertThisInitialized(self);
    }

    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return self;
    }

    function _wrapNativeSuper(Class) {
      var _cache = typeof Map === "function" ? new Map() : undefined;

      _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;

        if (typeof Class !== "function") {
          throw new TypeError("Super expression must either be null or a function");
        }

        if (typeof _cache !== "undefined") {
          if (_cache.has(Class)) return _cache.get(Class);

          _cache.set(Class, Wrapper);
        }

        function Wrapper() {
          return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }

        Wrapper.prototype = Object.create(Class.prototype, {
          constructor: {
            value: Wrapper,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        return _setPrototypeOf(Wrapper, Class);
      };

      return _wrapNativeSuper(Class);
    }

    function _construct(Parent, args, Class) {
      if (_isNativeReflectConstruct()) {
        _construct = Reflect.construct;
      } else {
        _construct = function _construct(Parent, args, Class) {
          var a = [null];
          a.push.apply(a, args);
          var Constructor = Function.bind.apply(Parent, a);
          var instance = new Constructor();
          if (Class) _setPrototypeOf(instance, Class.prototype);
          return instance;
        };
      }

      return _construct.apply(null, arguments);
    }

    function _isNativeReflectConstruct() {
      if (typeof Reflect === "undefined" || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if (typeof Proxy === "function") return true;

      try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        return true;
      } catch (e) {
        return false;
      }
    }

    function _isNativeFunction(fn) {
      return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }

    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };

      return _setPrototypeOf(o, p);
    }

    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
      return _getPrototypeOf(o);
    }

    var imageRegex = /*#__PURE__*/_wrapRegExp(/!\[((?:(?!\[)[\s\S])+)\]\(((?:(?!\))[\s\S]).*?)(?:[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]"(.*?)")?\)/, {
      alt: 1,
      src: 2,
      title: 3
    }); // sorta almost works, needs work...
    // const imageWithOptionalLinkRegex = /\[?!\[(?<alt>[^\[]+)\]\((?<src>[^\)].*?)(?:\s\"(?<title>.*?)\")?\)\]?(?:\((?<link_url>.*?)\))/;


    var Image = _styledComponents.default.img.withConfig({
      displayName: "Image",
      componentId: "beezxf-0"
    })(["max-width:93%;width:auto;"]);

    var inlineImage = function inlineImage(_ref) {
      var key = _ref.key;
      return function (content) {
        return (0, _utils.getChildComponents)(content, function (comp) {
          var imageWithOptionalLinkMatch = comp.match(imageRegex);

          if (imageWithOptionalLinkMatch && (imageWithOptionalLinkMatch === null || imageWithOptionalLinkMatch === void 0 ? void 0 : imageWithOptionalLinkMatch.length) > 0) {
            var _ref2 = (imageWithOptionalLinkMatch === null || imageWithOptionalLinkMatch === void 0 ? void 0 : imageWithOptionalLinkMatch.groups) || {},
                alt = _ref2.alt,
                src = _ref2.src,
                title = _ref2.title; // check to see if there is any text before/after


            var beforeAfterContent = comp.split(imageWithOptionalLinkMatch[0]).filter(Boolean);

            if (beforeAfterContent && beforeAfterContent.length > 0) {
              return /*#__PURE__*/_react.default.createElement("span", {
                key: key
              }, beforeAfterContent[0], /*#__PURE__*/_react.default.createElement(Image, {
                src: src,
                alt: alt,
                title: title
              }), beforeAfterContent[1]);
            } else {
              return /*#__PURE__*/_react.default.createElement(Image, {
                src: src,
                alt: alt,
                title: title,
                key: key
              });
            }
          }

          return comp;
        });
      };
    };

    exports.inlineImage = inlineImage;
    /***/
  },

  /***/
  "./src/parsers/lists/index.tsx":
  /***/
  function srcParsersListsIndexTsx(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.unOrderedList = exports.orderedList = void 0;

    var _react = _interopRequireDefault(__webpack_require__("react"));

    var _styledComponents = _interopRequireWildcard(__webpack_require__("styled-components"));

    var _utils = __webpack_require__("./src/utils/index.ts");

    function _getRequireWildcardCache() {
      if (typeof WeakMap !== "function") return null;
      var cache = new WeakMap();

      _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
      };

      return cache;
    }

    function _interopRequireWildcard(obj) {
      if (obj && obj.__esModule) {
        return obj;
      }

      if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
          default: obj
        };
      }

      var cache = _getRequireWildcardCache();

      if (cache && cache.has(obj)) {
        return cache.get(obj);
      }

      var newObj = {};
      var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

          if (desc && (desc.get || desc.set)) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }

      newObj.default = obj;

      if (cache) {
        cache.set(obj, newObj);
      }

      return newObj;
    }

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _wrapRegExp(re, groups) {
      _wrapRegExp = function _wrapRegExp(re, groups) {
        return new BabelRegExp(re, undefined, groups);
      };

      var _RegExp = _wrapNativeSuper(RegExp);

      var _super = RegExp.prototype;

      var _groups = new WeakMap();

      function BabelRegExp(re, flags, groups) {
        var _this = _RegExp.call(this, re, flags);

        _groups.set(_this, groups || _groups.get(re));

        return _this;
      }

      _inherits(BabelRegExp, _RegExp);

      BabelRegExp.prototype.exec = function (str) {
        var result = _super.exec.call(this, str);

        if (result) result.groups = buildGroups(result, this);
        return result;
      };

      BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
        if (typeof substitution === "string") {
          var groups = _groups.get(this);

          return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
            return "$" + groups[name];
          }));
        } else if (typeof substitution === "function") {
          var _this = this;

          return _super[Symbol.replace].call(this, str, function () {
            var args = [];
            args.push.apply(args, arguments);

            if (typeof args[args.length - 1] !== "object") {
              args.push(buildGroups(args, _this));
            }

            return substitution.apply(this, args);
          });
        } else {
          return _super[Symbol.replace].call(this, str, substitution);
        }
      };

      function buildGroups(result, re) {
        var g = _groups.get(re);

        return Object.keys(g).reduce(function (groups, name) {
          groups[name] = result[g[name]];
          return groups;
        }, Object.create(null));
      }

      return _wrapRegExp.apply(this, arguments);
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          writable: true,
          configurable: true
        }
      });
      if (superClass) _setPrototypeOf(subClass, superClass);
    }

    function _possibleConstructorReturn(self, call) {
      if (call && (typeof call === "object" || typeof call === "function")) {
        return call;
      }

      return _assertThisInitialized(self);
    }

    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return self;
    }

    function _wrapNativeSuper(Class) {
      var _cache = typeof Map === "function" ? new Map() : undefined;

      _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;

        if (typeof Class !== "function") {
          throw new TypeError("Super expression must either be null or a function");
        }

        if (typeof _cache !== "undefined") {
          if (_cache.has(Class)) return _cache.get(Class);

          _cache.set(Class, Wrapper);
        }

        function Wrapper() {
          return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }

        Wrapper.prototype = Object.create(Class.prototype, {
          constructor: {
            value: Wrapper,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        return _setPrototypeOf(Wrapper, Class);
      };

      return _wrapNativeSuper(Class);
    }

    function _construct(Parent, args, Class) {
      if (_isNativeReflectConstruct()) {
        _construct = Reflect.construct;
      } else {
        _construct = function _construct(Parent, args, Class) {
          var a = [null];
          a.push.apply(a, args);
          var Constructor = Function.bind.apply(Parent, a);
          var instance = new Constructor();
          if (Class) _setPrototypeOf(instance, Class.prototype);
          return instance;
        };
      }

      return _construct.apply(null, arguments);
    }

    function _isNativeReflectConstruct() {
      if (typeof Reflect === "undefined" || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if (typeof Proxy === "function") return true;

      try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        return true;
      } catch (e) {
        return false;
      }
    }

    function _isNativeFunction(fn) {
      return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }

    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };

      return _setPrototypeOf(o, p);
    }

    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
      return _getPrototypeOf(o);
    }

    var CustomList = (0, _styledComponents.css)(["list-style:none;& li:before{content:", ";margin-left:-20px;margin-right:10px;}"], function (props) {
      return "'" + props.content + "'" || false;
    });

    var CustomOrderedList = _styledComponents.default.ul.withConfig({
      displayName: "CustomOrderedList",
      componentId: "sc-7959eg-0"
    })(["margin-left:0px;margin-bottom:0.25rem;", ""], function (props) {
      return props.content && CustomList;
    });

    var orderedListRegex = /*#__PURE__*/_wrapRegExp(/^((\n[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])?([0-9]\.+)[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?(.*))+/i, {
      num: 3,
      content: 4
    });

    var unorderedListRegex = /*#__PURE__*/_wrapRegExp(/^((\x2D|\+)[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF](.*))/i, {
      content: 3
    });

    var orderedList = function orderedList(_ref) {
      var key = _ref.key;
      return function (content) {
        var orderedListMatch = (0, _utils.isString)(content) && content.match(orderedListRegex);

        if (orderedListMatch && orderedListMatch.length > 0) {
          var _orderedListMatch$gro;

          return /*#__PURE__*/_react.default.createElement(CustomOrderedList, {
            content: orderedListMatch === null || orderedListMatch === void 0 ? void 0 : orderedListMatch.groups.num,
            key: key
          }, /*#__PURE__*/_react.default.createElement("li", {
            key: key
          }, orderedListMatch === null || orderedListMatch === void 0 ? void 0 : (_orderedListMatch$gro = orderedListMatch.groups) === null || _orderedListMatch$gro === void 0 ? void 0 : _orderedListMatch$gro.content));
        }

        return content;
      };
    };

    exports.orderedList = orderedList;

    var unOrderedList = function unOrderedList(_ref2) {
      var key = _ref2.key;
      return function (content) {
        var unorderedListMatch = (0, _utils.isString)(content) && content.match(unorderedListRegex);

        if (unorderedListMatch && unorderedListMatch.length > 0) {
          var _unorderedListMatch$g;

          return /*#__PURE__*/_react.default.createElement(CustomOrderedList, {
            key: key
          }, /*#__PURE__*/_react.default.createElement("li", {
            key: key
          }, unorderedListMatch === null || unorderedListMatch === void 0 ? void 0 : (_unorderedListMatch$g = unorderedListMatch.groups) === null || _unorderedListMatch$g === void 0 ? void 0 : _unorderedListMatch$g.content));
        }

        return content;
      };
    };

    exports.unOrderedList = unOrderedList;
    /***/
  },

  /***/
  "./src/parsers/mustache/index.tsx":
  /***/
  function srcParsersMustacheIndexTsx(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.mustache = void 0;

    var _utils = __webpack_require__("./src/utils/index.ts");

    function _wrapRegExp(re, groups) {
      _wrapRegExp = function _wrapRegExp(re, groups) {
        return new BabelRegExp(re, undefined, groups);
      };

      var _RegExp = _wrapNativeSuper(RegExp);

      var _super = RegExp.prototype;

      var _groups = new WeakMap();

      function BabelRegExp(re, flags, groups) {
        var _this = _RegExp.call(this, re, flags);

        _groups.set(_this, groups || _groups.get(re));

        return _this;
      }

      _inherits(BabelRegExp, _RegExp);

      BabelRegExp.prototype.exec = function (str) {
        var result = _super.exec.call(this, str);

        if (result) result.groups = buildGroups(result, this);
        return result;
      };

      BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
        if (typeof substitution === "string") {
          var groups = _groups.get(this);

          return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
            return "$" + groups[name];
          }));
        } else if (typeof substitution === "function") {
          var _this = this;

          return _super[Symbol.replace].call(this, str, function () {
            var args = [];
            args.push.apply(args, arguments);

            if (typeof args[args.length - 1] !== "object") {
              args.push(buildGroups(args, _this));
            }

            return substitution.apply(this, args);
          });
        } else {
          return _super[Symbol.replace].call(this, str, substitution);
        }
      };

      function buildGroups(result, re) {
        var g = _groups.get(re);

        return Object.keys(g).reduce(function (groups, name) {
          groups[name] = result[g[name]];
          return groups;
        }, Object.create(null));
      }

      return _wrapRegExp.apply(this, arguments);
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          writable: true,
          configurable: true
        }
      });
      if (superClass) _setPrototypeOf(subClass, superClass);
    }

    function _possibleConstructorReturn(self, call) {
      if (call && (typeof call === "object" || typeof call === "function")) {
        return call;
      }

      return _assertThisInitialized(self);
    }

    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return self;
    }

    function _wrapNativeSuper(Class) {
      var _cache = typeof Map === "function" ? new Map() : undefined;

      _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;

        if (typeof Class !== "function") {
          throw new TypeError("Super expression must either be null or a function");
        }

        if (typeof _cache !== "undefined") {
          if (_cache.has(Class)) return _cache.get(Class);

          _cache.set(Class, Wrapper);
        }

        function Wrapper() {
          return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }

        Wrapper.prototype = Object.create(Class.prototype, {
          constructor: {
            value: Wrapper,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        return _setPrototypeOf(Wrapper, Class);
      };

      return _wrapNativeSuper(Class);
    }

    function _construct(Parent, args, Class) {
      if (_isNativeReflectConstruct()) {
        _construct = Reflect.construct;
      } else {
        _construct = function _construct(Parent, args, Class) {
          var a = [null];
          a.push.apply(a, args);
          var Constructor = Function.bind.apply(Parent, a);
          var instance = new Constructor();
          if (Class) _setPrototypeOf(instance, Class.prototype);
          return instance;
        };
      }

      return _construct.apply(null, arguments);
    }

    function _isNativeReflectConstruct() {
      if (typeof Reflect === "undefined" || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if (typeof Proxy === "function") return true;

      try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        return true;
      } catch (e) {
        return false;
      }
    }

    function _isNativeFunction(fn) {
      return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }

    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };

      return _setPrototypeOf(o, p);
    }

    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
      return _getPrototypeOf(o);
    }

    var doubleBrackRegex = /(?:\{\{)([^{}]*)(?:\}\})/gi;

    var tripleBracketsRegex = /*#__PURE__*/_wrapRegExp(/\{\{\{(.*)\}\}\}/i, {
      value: 1
    });

    var mustache = function mustache(_ref) {
      var data = _ref.data;
      return function (content) {
        var doubleBrackMatch = (0, _utils.isString)(content) && content.match(doubleBrackRegex);

        if (doubleBrackMatch) {
          var values = doubleBrackMatch.map(function (expression) {
            var value = expression.replace(/{/g, '').replace(/}/g, '').split('.').reduce(function (o, i) {
              return o && o[i];
            }, data);
            return {
              expression: expression,
              value: value
            };
          });
          return values.reduce(function (acc, _temp) {
            var _ref2 = _temp === void 0 ? {} : _temp,
                expression = _ref2.expression,
                value = _ref2.value;

            var containsTripleBrackets = content.match(tripleBracketsRegex);

            if (containsTripleBrackets) {
              return acc.replace(containsTripleBrackets[0], "\"" + value + "\"");
            }

            return acc.replace(expression, value === undefined ? '' : value);
          }, content);
        }

        return content;
      };
    };

    exports.mustache = mustache;
    /***/
  },

  /***/
  "./src/parsers/quote/index.tsx":
  /***/
  function srcParsersQuoteIndexTsx(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.quote = void 0;

    var _react = _interopRequireDefault(__webpack_require__("react"));

    var _styledComponents = _interopRequireDefault(__webpack_require__("styled-components"));

    var _utils = __webpack_require__("./src/utils/index.ts");

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _wrapRegExp(re, groups) {
      _wrapRegExp = function _wrapRegExp(re, groups) {
        return new BabelRegExp(re, undefined, groups);
      };

      var _RegExp = _wrapNativeSuper(RegExp);

      var _super = RegExp.prototype;

      var _groups = new WeakMap();

      function BabelRegExp(re, flags, groups) {
        var _this = _RegExp.call(this, re, flags);

        _groups.set(_this, groups || _groups.get(re));

        return _this;
      }

      _inherits(BabelRegExp, _RegExp);

      BabelRegExp.prototype.exec = function (str) {
        var result = _super.exec.call(this, str);

        if (result) result.groups = buildGroups(result, this);
        return result;
      };

      BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
        if (typeof substitution === "string") {
          var groups = _groups.get(this);

          return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
            return "$" + groups[name];
          }));
        } else if (typeof substitution === "function") {
          var _this = this;

          return _super[Symbol.replace].call(this, str, function () {
            var args = [];
            args.push.apply(args, arguments);

            if (typeof args[args.length - 1] !== "object") {
              args.push(buildGroups(args, _this));
            }

            return substitution.apply(this, args);
          });
        } else {
          return _super[Symbol.replace].call(this, str, substitution);
        }
      };

      function buildGroups(result, re) {
        var g = _groups.get(re);

        return Object.keys(g).reduce(function (groups, name) {
          groups[name] = result[g[name]];
          return groups;
        }, Object.create(null));
      }

      return _wrapRegExp.apply(this, arguments);
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          writable: true,
          configurable: true
        }
      });
      if (superClass) _setPrototypeOf(subClass, superClass);
    }

    function _possibleConstructorReturn(self, call) {
      if (call && (typeof call === "object" || typeof call === "function")) {
        return call;
      }

      return _assertThisInitialized(self);
    }

    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return self;
    }

    function _wrapNativeSuper(Class) {
      var _cache = typeof Map === "function" ? new Map() : undefined;

      _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;

        if (typeof Class !== "function") {
          throw new TypeError("Super expression must either be null or a function");
        }

        if (typeof _cache !== "undefined") {
          if (_cache.has(Class)) return _cache.get(Class);

          _cache.set(Class, Wrapper);
        }

        function Wrapper() {
          return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }

        Wrapper.prototype = Object.create(Class.prototype, {
          constructor: {
            value: Wrapper,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        return _setPrototypeOf(Wrapper, Class);
      };

      return _wrapNativeSuper(Class);
    }

    function _construct(Parent, args, Class) {
      if (_isNativeReflectConstruct()) {
        _construct = Reflect.construct;
      } else {
        _construct = function _construct(Parent, args, Class) {
          var a = [null];
          a.push.apply(a, args);
          var Constructor = Function.bind.apply(Parent, a);
          var instance = new Constructor();
          if (Class) _setPrototypeOf(instance, Class.prototype);
          return instance;
        };
      }

      return _construct.apply(null, arguments);
    }

    function _isNativeReflectConstruct() {
      if (typeof Reflect === "undefined" || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if (typeof Proxy === "function") return true;

      try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        return true;
      } catch (e) {
        return false;
      }
    }

    function _isNativeFunction(fn) {
      return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }

    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };

      return _setPrototypeOf(o, p);
    }

    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
      return _getPrototypeOf(o);
    }

    var Quote = _styledComponents.default.div.withConfig({
      displayName: "Quote",
      componentId: "nxf40m-0"
    })(["margin:0;padding-left:1.4rem;border-left:4px solid #dadada;"]);

    var quoteRegex = /*#__PURE__*/_wrapRegExp(/^(>+[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*)(.*)/i, {
      quote: 2
    }); // A quote applies to the whole line, so we only care about strings here, and not other react components


    var quote = function quote(_ref) {
      var key = _ref.key;
      return function (content) {
        return (0, _utils.getChildComponents)(content, function (comp) {
          var quoteMatch = comp.match(quoteRegex);

          if (quoteMatch && quoteMatch.length > 0) {
            var _quoteMatch$groups;

            return /*#__PURE__*/_react.default.createElement(Quote, {
              key: key
            }, quoteMatch === null || quoteMatch === void 0 ? void 0 : (_quoteMatch$groups = quoteMatch.groups) === null || _quoteMatch$groups === void 0 ? void 0 : _quoteMatch$groups.quote);
          }

          return comp;
        });
      };
    };

    exports.quote = quote;
    /***/
  },

  /***/
  "./src/parsers/url-link/index.tsx":
  /***/
  function srcParsersUrlLinkIndexTsx(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.urlLink = void 0;

    var _react = _interopRequireDefault(__webpack_require__("react"));

    var _styledComponents = _interopRequireDefault(__webpack_require__("styled-components"));

    var _utils = __webpack_require__("./src/utils/index.ts");

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _wrapRegExp(re, groups) {
      _wrapRegExp = function _wrapRegExp(re, groups) {
        return new BabelRegExp(re, undefined, groups);
      };

      var _RegExp = _wrapNativeSuper(RegExp);

      var _super = RegExp.prototype;

      var _groups = new WeakMap();

      function BabelRegExp(re, flags, groups) {
        var _this = _RegExp.call(this, re, flags);

        _groups.set(_this, groups || _groups.get(re));

        return _this;
      }

      _inherits(BabelRegExp, _RegExp);

      BabelRegExp.prototype.exec = function (str) {
        var result = _super.exec.call(this, str);

        if (result) result.groups = buildGroups(result, this);
        return result;
      };

      BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
        if (typeof substitution === "string") {
          var groups = _groups.get(this);

          return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
            return "$" + groups[name];
          }));
        } else if (typeof substitution === "function") {
          var _this = this;

          return _super[Symbol.replace].call(this, str, function () {
            var args = [];
            args.push.apply(args, arguments);

            if (typeof args[args.length - 1] !== "object") {
              args.push(buildGroups(args, _this));
            }

            return substitution.apply(this, args);
          });
        } else {
          return _super[Symbol.replace].call(this, str, substitution);
        }
      };

      function buildGroups(result, re) {
        var g = _groups.get(re);

        return Object.keys(g).reduce(function (groups, name) {
          groups[name] = result[g[name]];
          return groups;
        }, Object.create(null));
      }

      return _wrapRegExp.apply(this, arguments);
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          writable: true,
          configurable: true
        }
      });
      if (superClass) _setPrototypeOf(subClass, superClass);
    }

    function _possibleConstructorReturn(self, call) {
      if (call && (typeof call === "object" || typeof call === "function")) {
        return call;
      }

      return _assertThisInitialized(self);
    }

    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return self;
    }

    function _wrapNativeSuper(Class) {
      var _cache = typeof Map === "function" ? new Map() : undefined;

      _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;

        if (typeof Class !== "function") {
          throw new TypeError("Super expression must either be null or a function");
        }

        if (typeof _cache !== "undefined") {
          if (_cache.has(Class)) return _cache.get(Class);

          _cache.set(Class, Wrapper);
        }

        function Wrapper() {
          return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }

        Wrapper.prototype = Object.create(Class.prototype, {
          constructor: {
            value: Wrapper,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        return _setPrototypeOf(Wrapper, Class);
      };

      return _wrapNativeSuper(Class);
    }

    function _construct(Parent, args, Class) {
      if (_isNativeReflectConstruct()) {
        _construct = Reflect.construct;
      } else {
        _construct = function _construct(Parent, args, Class) {
          var a = [null];
          a.push.apply(a, args);
          var Constructor = Function.bind.apply(Parent, a);
          var instance = new Constructor();
          if (Class) _setPrototypeOf(instance, Class.prototype);
          return instance;
        };
      }

      return _construct.apply(null, arguments);
    }

    function _isNativeReflectConstruct() {
      if (typeof Reflect === "undefined" || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if (typeof Proxy === "function") return true;

      try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        return true;
      } catch (e) {
        return false;
      }
    }

    function _isNativeFunction(fn) {
      return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }

    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };

      return _setPrototypeOf(o, p);
    }

    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
      return _getPrototypeOf(o);
    }

    var UrlLink = _styledComponents.default.a.withConfig({
      displayName: "UrlLink",
      componentId: "m7by91-0"
    })(["text-decoration:underline;color:", ";&:hover{color:", ";}"], function (props) {
      return props.theme.color.primary.v200;
    }, function (props) {
      return props.theme.color.primary.v200;
    });

    var linkRegex = /*#__PURE__*/_wrapRegExp(/((?!(!)).|^)\[((?:(?!\[)[\s\S])+)\]\(((?:(?!\))[\s\S])+)\)/gi, {
      title: 3,
      url: 4
    });

    var internal = function internal(to) {
      return /^\/(?!\/)/.test(to);
    };

    var urlLink = function urlLink(_temp) {
      var _ref = _temp === void 0 ? {} : _temp,
          key = _ref.key,
          TempGatsbyUrlLink = _ref.TempGatsbyUrlLink;

      return function (content) {
        return (0, _utils.getChildComponents)(Array.isArray(content) ? content[0] : content, function (comp) {
          var linkMatch = comp.match(linkRegex);

          if (linkMatch && linkMatch.length > 0) {
            // split string on all [title](url) instances
            var splitUrlString = comp.split(/(\[(?:.*?)\]\((?:.*?)\))/).filter(Boolean); // loop through, and then check to see if we have a match with linkMatch (original one that matches all links)
            // if we have a match, then once again go through regex, and get title, and url

            var arrayOfSplitUrlString = splitUrlString.map(function (x) {
              var isAMatch = !!linkMatch.find(function (y) {
                return y.trim() === x;
              });

              if (isAMatch) {
                var urlMatched = x.match( /*#__PURE__*/_wrapRegExp(/\[(.*?)\]\((.*?)\)/, {
                  title: 1,
                  url: 2
                }));

                if (urlMatched && urlMatched.groups.title && urlMatched.groups.url) {
                  if (internal(urlMatched.groups.url) && !TempGatsbyUrlLink) {
                    return /*#__PURE__*/_react.default.createElement(UrlLink, {
                      as: TempGatsbyUrlLink,
                      key: [key, Date.now(), urlMatched.groups.title].join('-'),
                      to: urlMatched.groups.url
                    }, urlMatched.groups.title);
                  }

                  var href = internal(urlMatched.groups.url) && !urlMatched.groups.url.includes('/help') ? "/help" + urlMatched.groups.url : urlMatched.groups.url;
                  return /*#__PURE__*/_react.default.createElement(UrlLink, {
                    as: "a",
                    key: [key, Date.now(), urlMatched.groups.title].join('-'),
                    href: href
                  }, urlMatched.groups.title);
                }
              }

              return x;
            });
            return arrayOfSplitUrlString;
          }

          return comp;
        });
      };
    };

    exports.urlLink = urlLink;
    /***/
  },

  /***/
  "./src/utils/get-child-components/index.ts":
  /***/
  function srcUtilsGetChildComponentsIndexTs(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.getChildComponents = void 0;

    var _isString = __webpack_require__("./src/utils/is-string/index.ts");

    var _replaceChildrenComponent = __webpack_require__("./src/utils/replace-children-component/index.ts");

    var _getChildContent = __webpack_require__("./src/utils/get-child-content/index.ts"); // @ts-nocheck


    var getChildComponents = function getChildComponents(content, cb) {
      return [content].flat().map(function (component) {
        var childComponent = [(0, _getChildContent.getChildContent)(component)].flat();
        var newChildComponents = childComponent.map(function (comp) {
          // we only deal with strings
          if ((0, _isString.isString)(comp)) {
            // call function that deals with matching
            return cb(comp);
          }

          return comp;
        }).flat();
        var result = (0, _isString.isString)(component) || Array.isArray(component) && component.length === 1 ? newChildComponents && newChildComponents.length > 0 ? newChildComponents : component : newChildComponents && newChildComponents.length > 0 ? (0, _replaceChildrenComponent.replaceChildrenComponent)(component, newChildComponents) : component;

        if (result && result.length > 0) {
          if (Array.isArray(component) && component.length === 1) return result[0];
          return result;
        }

        return result;
      });
    };

    exports.getChildComponents = getChildComponents;
    /***/
  },

  /***/
  "./src/utils/get-child-content/index.ts":
  /***/
  function srcUtilsGetChildContentIndexTs(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.getChildContent = void 0;

    var _isString = __webpack_require__("./src/utils/is-string/index.ts"); // @ts-nocheck


    var getChildContent = function getChildContent(content) {
      var _content$props, _content$props$childr, _content$props$childr2, _content$props2; // only goes two deep for child component


      return (0, _isString.isString)(content) ? content : (content === null || content === void 0 ? void 0 : (_content$props = content.props) === null || _content$props === void 0 ? void 0 : (_content$props$childr = _content$props.children) === null || _content$props$childr === void 0 ? void 0 : (_content$props$childr2 = _content$props$childr.props) === null || _content$props$childr2 === void 0 ? void 0 : _content$props$childr2.children) || (content === null || content === void 0 ? void 0 : (_content$props2 = content.props) === null || _content$props2 === void 0 ? void 0 : _content$props2.children) || content;
    };

    exports.getChildContent = getChildContent;
    /***/
  },

  /***/
  "./src/utils/has-children/index.ts":
  /***/
  function srcUtilsHasChildrenIndexTs(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.hasChildren = void 0; // @ts-nocheck

    var hasChildren = function hasChildren(content) {
      var _content$props, _content$props$childr, _content$props$childr2, _content$props2;

      return (content === null || content === void 0 ? void 0 : (_content$props = content.props) === null || _content$props === void 0 ? void 0 : (_content$props$childr = _content$props.children) === null || _content$props$childr === void 0 ? void 0 : (_content$props$childr2 = _content$props$childr.props) === null || _content$props$childr2 === void 0 ? void 0 : _content$props$childr2.children) || (content === null || content === void 0 ? void 0 : (_content$props2 = content.props) === null || _content$props2 === void 0 ? void 0 : _content$props2.children);
    };

    exports.hasChildren = hasChildren;
    /***/
  },

  /***/
  "./src/utils/index.ts":
  /***/
  function srcUtilsIndexTs(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _hasChildren = __webpack_require__("./src/utils/has-children/index.ts");

    Object.keys(_hasChildren).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      if (key in exports && exports[key] === _hasChildren[key]) return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _hasChildren[key];
        }
      });
    });

    var _isElement = __webpack_require__("./src/utils/is-element/index.ts");

    Object.keys(_isElement).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      if (key in exports && exports[key] === _isElement[key]) return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _isElement[key];
        }
      });
    });

    var _isString = __webpack_require__("./src/utils/is-string/index.ts");

    Object.keys(_isString).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      if (key in exports && exports[key] === _isString[key]) return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _isString[key];
        }
      });
    });

    var _pipe = __webpack_require__("./src/utils/pipe/index.ts");

    Object.keys(_pipe).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      if (key in exports && exports[key] === _pipe[key]) return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _pipe[key];
        }
      });
    });

    var _getChildContent = __webpack_require__("./src/utils/get-child-content/index.ts");

    Object.keys(_getChildContent).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      if (key in exports && exports[key] === _getChildContent[key]) return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _getChildContent[key];
        }
      });
    });

    var _replaceChildrenComponent = __webpack_require__("./src/utils/replace-children-component/index.ts");

    Object.keys(_replaceChildrenComponent).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      if (key in exports && exports[key] === _replaceChildrenComponent[key]) return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _replaceChildrenComponent[key];
        }
      });
    });

    var _getChildComponents = __webpack_require__("./src/utils/get-child-components/index.ts");

    Object.keys(_getChildComponents).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      if (key in exports && exports[key] === _getChildComponents[key]) return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _getChildComponents[key];
        }
      });
    });
    /***/
  },

  /***/
  "./src/utils/is-element/index.ts":
  /***/
  function srcUtilsIsElementIndexTs(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.isElement = void 0;

    var _react = _interopRequireDefault(__webpack_require__("react"));

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var isElement = function isElement(element) {
      return _react.default.isValidElement(element);
    };

    exports.isElement = isElement;
    /***/
  },

  /***/
  "./src/utils/is-string/index.ts":
  /***/
  function srcUtilsIsStringIndexTs(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.isString = void 0;

    var isString = function isString(s) {
      return typeof s === 'string';
    };

    exports.isString = isString;
    /***/
  },

  /***/
  "./src/utils/pipe/index.ts":
  /***/
  function srcUtilsPipeIndexTs(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.pipe = void 0;

    var pipe = function pipe() {
      for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
        fns[_key] = arguments[_key];
      }

      return function (x) {
        return fns.reduce(function (v, f) {
          return f(v);
        }, x);
      };
    };

    exports.pipe = pipe;
    /***/
  },

  /***/
  "./src/utils/replace-children-component/index.ts":
  /***/
  function srcUtilsReplaceChildrenComponentIndexTs(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.replaceChildrenComponent = void 0;

    var _react = _interopRequireDefault(__webpack_require__("react"));

    var _isString = __webpack_require__("./src/utils/is-string/index.ts");

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _extends() {
      _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      return _extends.apply(this, arguments);
    }

    var replaceChildrenComponent = function replaceChildrenComponent(content, newChild) {
      try {
        var _content$props, _content$props2, _content$props2$child, _content$props3, _content$props3$child, _content$props3$child2, _content$props6;

        if ((0, _isString.isString)(content)) return content;
        if (((_content$props = content.props) === null || _content$props === void 0 ? void 0 : _content$props.children) === newChild || ((_content$props2 = content.props) === null || _content$props2 === void 0 ? void 0 : (_content$props2$child = _content$props2.children) === null || _content$props2$child === void 0 ? void 0 : _content$props2$child.props) === newChild) return content;

        if (content && (content === null || content === void 0 ? void 0 : (_content$props3 = content.props) === null || _content$props3 === void 0 ? void 0 : (_content$props3$child = _content$props3.children) === null || _content$props3$child === void 0 ? void 0 : (_content$props3$child2 = _content$props3$child.props) === null || _content$props3$child2 === void 0 ? void 0 : _content$props3$child2.children)) {
          var _content$props4, _content$props5, _content$props5$child;

          return _react.default.cloneElement(content, _extends({}, content.props), _react.default.cloneElement((_content$props4 = content.props) === null || _content$props4 === void 0 ? void 0 : _content$props4.children, _extends({}, (_content$props5 = content.props) === null || _content$props5 === void 0 ? void 0 : (_content$props5$child = _content$props5.children) === null || _content$props5$child === void 0 ? void 0 : _content$props5$child.props), newChild));
        }

        if (content && (content === null || content === void 0 ? void 0 : (_content$props6 = content.props) === null || _content$props6 === void 0 ? void 0 : _content$props6.children)) {
          return _react.default.cloneElement(content, _extends({}, content.props), newChild);
        }

        return content;
      } catch (error) {
        console.error('failed to replace children', error);
        return content;
      }
    };

    exports.replaceChildrenComponent = replaceChildrenComponent;
    /***/
  },

  /***/
  "@carvana/core-delivery-or-pickup":
  /***/
  function carvanaCoreDeliveryOrPickup(module, exports) {
    module.exports = require("@carvana/core-delivery-or-pickup");
    /***/
  },

  /***/
  "nanoid":
  /***/
  function nanoid(module, exports) {
    module.exports = require("nanoid");
    /***/
  },

  /***/
  "react":
  /***/
  function react(module, exports) {
    module.exports = require("react");
    /***/
  },

  /***/
  "styled-components":
  /***/
  function styledComponents(module, exports) {
    module.exports = require("styled-components");
    /***/
  }
  /******/

});